/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { ArrowLink, Container, Stack, Text } from "@carrotfertility/carotene"
import { CircleImage } from "../CircleImage"
import { ZendeskArrowLink } from "../../../../components/views/atoms/links/ZendeskArrowLink"
import { SupportCenterLinks } from "../../../../utils/SupportCenterLinks"
import { FormattedMessage } from "react-intl"

export function SidebarHelp(): JSX.Element {
  return (
    <Container
      minHeight="178px"
      background="mintAlternate"
      borderRadius="8px"
      padding="medium"
      sx={{ marginBottom: "88px" }}
    >
      <Stack spacing="tiny">
        <CircleImage name="icn-help" />
        <Text font="gotham" weight="bold">
          <FormattedMessage defaultMessage="Can we help?" />
        </Text>
        <ArrowLink to="/talk-to-carrot/sendmessage/helpfindingprovider">
          <FormattedMessage defaultMessage="Contact our Care Navigation team" />
        </ArrowLink>
        <ZendeskArrowLink supportCenterLink={SupportCenterLinks.CARROT_PROVIDERS}>
          <FormattedMessage defaultMessage="Learn more" />
        </ZendeskArrowLink>
      </Stack>
    </Container>
  )
}
